import { render, staticRenderFns } from "./MsiHeader.vue?vue&type=template&id=70d1e711&"
import script from "./MsiHeader.vue?vue&type=script&lang=js&"
export * from "./MsiHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports